import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { selectSiteData } from "../../../../../store/selectors/commonSelectors";

const FooterBottom = () => {
  const handleClick = () => {
    window.scroll(0, 0);
  };
  const siteData = useSelector(selectSiteData);
  return (
    <div className="footer-bottom">
      <div className="container">
        <div className="row y-middle">
          <div className="col-lg-6 text-rightFooter md-text-center md-mb-10 order-last">
            <ul className="copy-right-menu">
              <li>
                <Link to="/" onClick={handleClick}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={handleClick}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/service" onClick={handleClick}>
                  Services
                </Link>
              </li>
              <li>
                <a
                  href="https://blog.techniajz.com/blogs"
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleClick}
                >
                  Blog
                </a>
              </li>
              <li>
                <Link to="/contact" onClick={handleClick}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-6">
            <div className="copyright md-text-center md-mb-10">
              <p>
                {siteData.copyrighttext}
                {/* <a href="#">Techniajz</a> */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterBottom;
